import { Component, Input } from '@angular/core';
import { CustomHubCategory } from '~app/modules/custom-hub/models';

@Component({
  selector: 'app-custom-hub-grid',
  templateUrl: './custom-hub-grid.component.html',
  styleUrls: ['./custom-hub-grid.component.scss']
})
export class CustomHubGridComponent {
  @Input() categories: CustomHubCategory[];
  @Input() isMobileOrTablet: boolean;

  counter = 0;

  constructor(
  ) {}
}
